'use client';

import { RefObject } from 'react';

import { MediaChromeCastButton } from './MediaChromeCastButton';
import { VimeoCastButton } from './VimeoCastButton';

import type { PlayerType } from '@/lib/api/types';

interface Props {
  type: PlayerType;
  videoRef: RefObject<HTMLVideoElement | null>;
  disabled?: boolean;
}

export function PlayerCastButton({ type, videoRef, disabled = false }: Props) {
  if (type === 'vimeo') {
    return <VimeoCastButton videoRef={videoRef} disabled={disabled} />;
  }

  if (type === 'mux' || type === 'hls') {
    return <MediaChromeCastButton disabled={disabled} />;
  }
}
